import axios, { AxiosResponse } from "axios"; // Assuming Axios is installed
import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { ServerResponse_ } from "@/interfaces/Server";
import { list_status_tounee } from "@/constants/urls";
import { Status } from "@/interfaces/Return";

export const getReturnStatus = async (): Promise<
  AxiosResponse<ServerResponse_<{ list: Status[] }>>
> => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<{ list: Status[] }>> =
      await axios.get(list_status_tounee, {
        headers: defaultHeadersWithToken(accessToken),
      });
    return response;
  } catch (error: any) {
    return error.response;
  }
};
